import { Menu } from "../models/menu.model";
import { MenuLevel } from "../models/menu.model";
import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";
import { UserModel } from "../models/user.model";
import menuLst from "../configs/menu.json";

const basePath = "/Config";
const request = HttpService.handleRequest();

export const ConfigService = {
  getAll,
  getList,
  insert,
  update,
  del,
  getById,
  remove,
  insertOrUpdate,
  getByKey,
  GetByKeyAndLocale,
  GetConfigImpositionListByType,
  SaveImpositionList
};

async function getAll() {
  return request.get(basePath);
}

async function insertOrUpdate(data) {
  return request.post(`${basePath}/create`, data);
}

async function insert(data) {
  return request.post(`${basePath}/create`, data);
}

async function update(data) {
  return request.put(basePath, data);
}

async function del(data) {
  return request.delete(basePath, data);
}

async function remove(data) {
  return request.post(`${basePath}/remove`, data);
}

async function getById(id) {
  return request.get(`${basePath}/${id}`);
}

async function getList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

async function SaveImpositionList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/SaveImpositionList`, data);
}

async function getByKey(key) {
  return request.get(`${basePath}/key/${key}`);
}

async function GetByKeyAndLocale(key) {
  return request.get(`${basePath}/key/${key}/locale`);
}

async function GetConfigImpositionListByType(type) {
  return request.get(`${basePath}/impositionListByType/${type}`);
}

function getUser(): UserModel {
	return JSON.parse(localStorage.getItem("User"));
}

export default ConfigService;
